<template>
  <div>
    <component
      v-for="part in filteredParts"
      :is="UserFormPart(part.part_type)"
      :key="part.id"
      :userFormId="userFormId"
      :section="part"
      :question="part"
      :paragraph="part"
      :read-only="readOnly || false"
    />
  </div>
</template>

<script>
import UserFormSection from './UserFormSection'
import UserFormQuestion from './UserFormQuestion'
import UserFormParagraph from './UserFormParagraph'
import UserFormEsignature from './UserFormEsignature'

export default {
  name: 'UserFormPartList',
  props: [ 'userFormId', 'parts', 'readOnly' ],
  components: {
    UserFormSection,
    UserFormQuestion,
    UserFormParagraph,
    UserFormEsignature
  },
  computed: {
    filteredParts () {
      return this.parts.filter((p) => {
        return p.pdf_only == false
      })
    }
  },
  methods: {
    UserFormPart (PartType) {
      switch (PartType) {
        case 's':
          return 'UserFormSection'
        case 'q':
          return 'UserFormQuestion'
        case 'p':
          return 'UserFormParagraph'
        case 'e':
          return 'UserFormEsignature'
      }
    }
  }
}
</script>
